import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { checkHOD, checkHOU } from '../../permission-utils/settings';
import { hasViewPatientProfilePermission } from '../../permission-utils/patient';

const PayPointMenu = () => {
	const [isSupervisor, setIsSuperVisor] = useState(false);
	const user = useSelector(state => state.user.profile);

	useEffect(() => {
		const fetchData = async () => {
			const isHOD = await checkHOD();
			const isHOU = await checkHOU();

			if (isHOD || isHOU) {
				setIsSuperVisor(true);
			}
		};

		fetchData();
	}, []);

	return (
		<>
			{isSupervisor && (
				<li>
					<Link to="/paypoint/overview">
						<div className="icon-w">
							<div className="icon-feather-home" />
						</div>
						<span>Overview</span>
					</Link>
				</li>
			)}
			<li>
				<Link to="/paypoint">
					<div className="icon-w">
						<div className="icon-feather-home" />
					</div>
					<span>Home</span>
				</Link>
			</li>
			{user.role.slug === 'paypoint' && (
				<li>
					<Link to="/front-desk/admitted">
						<div className="icon-w">
							<div className="icon-feather-folder-plus" />
						</div>
						<span>Admitted Patients</span>
					</Link>
				</li>
			)}
			<li>
				<Link to="/nurse/in-patients/admitted">
					<div className="icon-w">
						<div className="icon-feather-folder-plus" />
					</div>
					<span>In-Patient</span>
				</Link>
			</li>
			{/* <li>
				<Link to="/paypoint/new-transaction">
					<div className="icon-w">
						<div className="icon-feather-plus-square" />
					</div>
					<span>New Transaction</span>
				</Link>
			</li> */}
			<li>
				<Link to="/paypoint/pending-bills">
					<div className="icon-w">
						<div className="icon-feather-file-text" />
					</div>
					<span>Pending Bills</span>
				</Link>
			</li>
			<li>
				<Link to="/paypoint/pending-bills-opd">
					<div className="icon-w">
						<div className="icon-feather-file-text" />
					</div>
					<span>Pending Bills UNREG</span>
				</Link>
			</li>
			<li>
				<Link to="/paypoint/transaction-history">
					<div className="icon-w">
						<div className="os-icon os-icon-agenda-1" />
					</div>
					<span>Transaction History</span>
				</Link>
			</li>
			<li>
				<Link to="/accounting/discharge-queue">
					<div className="icon-w">
						<div className="icon-feather-log-out" />
					</div>
					<span>Discharge Queue</span>
				</Link>
			</li>
			<li>
				<Link to="/nicu">
					<div className="icon-w">
						<div className="os-icon os-icon-documents-03" />
					</div>
					<span>NICU</span>
				</Link>
			</li>
			<li>
				<Link to="/paypoint/vouchers">
					<div className="icon-w">
						<div className="os-icon os-icon-newspaper" />
					</div>
					<span>Vouchers</span>
				</Link>
			</li>
			{isSupervisor && (
				<li>
					<Link to="/report/income">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Reports</span>
					</Link>
				</li>
			)}
		</>
	);
};

export default PayPointMenu;
